import { createAction } from 'redux-actions'
import Api from '../Api'

import { setAlert } from './alerts'
import { clearModal } from './modal'
// import { fetchDashboard } from './dashboard'

export const CREATE_RIDER_REQUEST = createAction('CREATE_RIDER_REQUEST')
export const FULFILL_RIDER_REQUEST = createAction('FULFILL_RIDER_REQUEST')
export const DELETE_RIDER_REQUEST = createAction('DELETE_RIDER_REQUEST')

export const createRiderRequest = (eventId, request) => {
  return (dispatch) => {
    dispatch(clearModal())

    return Api.createRiderRequest(eventId, request)
      .then(response => {
        dispatch(CREATE_RIDER_REQUEST({data: response.data}))
        dispatch(setAlert('We have successfully sent out rider request', undefined, 'success'))
      })
      .catch(error => dispatch(setAlert('Sorry, we were unable to create this rider.', undefined, 'error')))
  }
}

export const fulfillRiderRequest = (requestId, riderId) => {
  return (dispatch) => {
    dispatch(clearModal())

    return Api.fulfillRiderRequest(requestId, riderId)
      .then(response => {
        dispatch(FULFILL_RIDER_REQUEST({data: response.data}))
        // dispatch(fetchDashboard()) // TODO: Enable when createdEventId is disabled
      })
      .catch(error => dispatch(setAlert('Sorry, we were unable to create this rider.', undefined, 'error')))
  }
}

export const deleteRiderRequest = (requestId) => {
  return (dispatch) => {
    dispatch(clearModal())

    return dispatch(DELETE_RIDER_REQUEST(Api.deleteRiderRequest(requestId)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/event-rider-request.js